export default "__VITE_ASSET__72a26756__"